import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  RemoveBlockTool,
  ImageBlockLinkTool,
  BlockLeftAlignTool,
  BlockRightAlignTool,
  BlockCenterAlignTool,
  BlockSizeTool,
} from '@nextiva/rich-text-editor';

import { openInsertImageLinkIntoEditorModal } from '../../../../actions/richTextEditorModalActions';

import styles from './ImageToolbar.scss';

const toolStyles = {
  className: styles.tool,
  activeClassName: styles.toolActive,
};

class ImageToolbar extends React.Component {
  static propTypes = {
    editorId: PropTypes.string.isRequired,
    blockKey: PropTypes.string.isRequired,
    editorState: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onInsertImageLink: PropTypes.func.isRequired,
  };

  handleInsertImageLink = link => {
    const { editorId, onInsertImageLink } = this.props;

    onInsertImageLink(editorId, link);
  };

  render = () => {
    const { editorState, onChange, blockKey } = this.props;

    return (
      <div className={styles.toolbar}>
        <div className={styles.group}>
          <BlockSizeTool
            editorState={editorState}
            onChange={onChange}
            blockWidth={200}
            blockKey={blockKey}
            iconClassName={`icon-custom-image-placeholder ${
              styles.smallImageIcon
            }`}
            tooltip="Small"
            {...toolStyles}
          />
          <BlockSizeTool
            editorState={editorState}
            onChange={onChange}
            blockKey={blockKey}
            blockWidth={300}
            iconClassName={`icon-custom-image-placeholder ${
              styles.mediumImageIcon
            }`}
            tooltip="Medium"
            {...toolStyles}
          />
          <BlockSizeTool
            editorState={editorState}
            onChange={onChange}
            blockKey={blockKey}
            blockWidth={500}
            iconClassName="icon-custom-image-placeholder"
            tooltip="Large"
            {...toolStyles}
          />
        </div>
        <div className={styles.group}>
          <BlockLeftAlignTool
            editorState={editorState}
            onChange={onChange}
            {...toolStyles}
          />
          <BlockCenterAlignTool
            editorState={editorState}
            onChange={onChange}
            {...toolStyles}
          />
          <BlockRightAlignTool
            editorState={editorState}
            onChange={onChange}
            {...toolStyles}
          />
        </div>
        <div className={styles.group}>
          <ImageBlockLinkTool
            editorState={editorState}
            onClick={this.handleInsertImageLink}
            {...toolStyles}
          />
          <RemoveBlockTool
            editorState={editorState}
            onChange={onChange}
            blockKey={blockKey}
            tooltip="Delete image"
            {...toolStyles}
          />
        </div>
      </div>
    );
  };
}

const mapDispatchToProps = {
  onInsertImageLink: openInsertImageLinkIntoEditorModal,
};

export default connect(
  null,
  mapDispatchToProps,
)(ImageToolbar);
